import { render, staticRenderFns } from "./Q_AreaCheck.vue?vue&type=template&id=19c18346&scoped=true"
import script from "./Q_AreaCheck.vue?vue&type=script&lang=js"
export * from "./Q_AreaCheck.vue?vue&type=script&lang=js"
import style0 from "./Q_AreaCheck.vue?vue&type=style&index=0&id=19c18346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c18346",
  null
  
)

export default component.exports